export enum EConsultationRequestActions {
  SetActiveStep = 'consultationRequest/setActiveStep',
  SetServiceButtonOffset = 'consultationRequest/setServiceButtonOffset',
}
